// components/ErrorFallback.jsx
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { Layout } from "./Components/Layout/Layout";
import { useTranslation } from "react-i18next";

const ErrorFallback = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Layout noPaddingPage>
      <Result
        status="500"
        title={t("errorPage.somethingWrong")}
        subTitle={t("errorPage.unexpectedError")}
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            {t("errorPage.backHome")}
          </Button>
        }
      />
    </Layout>
  );
};

export default ErrorFallback;
